// Backend hata gövdesini tek bir metne indirger. Desteklenen biçimler:
//   düz metin
//   { message, errors: [{ code, message }] }   Identity  -> errors DİZİ
//   { title, errors: { Alan: ["..."] } }       ProblemDetails -> errors NESNE
//   { message, details: ["..."] }              ErrorResponseModel
// errors'ın iki farklı şekli yüzünden collectErrors ikisini de ele almalı.

const DEFAULT_FALLBACK = 'An unexpected error occurred.';

const asText = value => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (value && typeof value === 'object') {
    return asText(value.message ?? value.Message ?? value.description ?? '');
  }
  return '';
};

const collectErrors = errors => {
  if (!errors) return [];

  const values = Array.isArray(errors) ? errors : Object.values(errors);

  return values.flat().map(asText).filter(Boolean);
};

// ErrorResponseModel.message varsayılanı literal "failed"; asıl bilgi
// details'te olduğu için bunu mesaj saymıyoruz.
const isPlaceholderMessage = text => /^(failed|error)$/i.test(text);

export const getApiErrorMessage = (error, fallback = DEFAULT_FALLBACK) => {
  const data = error?.response?.data;

  // Cevap yoksa istek sunucuya ulaşmamıştır; doğrulama hatası gibi
  // göstermek yanıltıcı olur.
  if (!error?.response && (error?.request || error?.code === 'ERR_NETWORK')) {
    return 'Cannot reach the server. Check your connection and try again.';
  }

  if (typeof data === 'string' && data.trim()) return data.trim();

  if (data && typeof data === 'object') {
    const fromErrors = collectErrors(data.errors ?? data.Errors);
    if (fromErrors.length) return fromErrors.join(' ');

    const message = asText(data.message ?? data.Message);
    if (message && !isPlaceholderMessage(message)) return message;

    const details = collectErrors(data.details ?? data.Details);
    if (details.length) return details.join(' ');

    const title = asText(data.title ?? data.Title);
    if (title) return title;

    if (message) return message;
  }

  // Sarmalanmış `new Error(mesaj)` durumunda elimizde sadece bu kalır.
  // Axios'un kendi genel metinleri kullanıcıya bir şey anlatmıyor.
  const thrownMessage = asText(error?.message);
  if (
    thrownMessage &&
    !/^Request failed with status code/i.test(thrownMessage) &&
    !/^Network Error$/i.test(thrownMessage)
  ) {
    return thrownMessage;
  }

  return fallback;
};

export default getApiErrorMessage;
